import React, { useCallback, useState } from 'react';
import { FieldType } from '../../../../containers/schema-mapper/interfaces/interfaces';
import { getDataIdGenerator } from '../../../../core/utils/generateDataId';
import { HdIcon, HdIconButton, HdTooltip, HdKeyBadge } from '../../../../components';
import { IField } from '../../interfaces/form';

import { getSourceFieldDataTypeDisplay, constructDisplayField } from '../../utils/schemaBuilder';
import styles from './SourceSchema.module.scss';
import { NestedFieldExplorer } from '../nested-field-explorer-dialog/NestedFieldExplorer';

export function SourceSchema({ field, dataId }: { field: IField; dataId: string }) {
  const [isOpen, setOpen] = useState(false);

  const isStructField = () =>
    Boolean(
      field.source.meta_type === FieldType.STRUCT ||
        (field.source.meta_type === FieldType.ARRAY &&
          field.source.value_type?.type_display === 'struct')
    );

  const dataIdGenerator = useCallback(getDataIdGenerator(dataId, 'source-schema'), [dataId]);

  return (
    <div className={styles.rootContainer}>
      <HdTooltip title={field.source.name} enableOnTextOverflow>
        <span className={`${styles.fieldName} text-ellipsis`}> {field.source.name}</span>
      </HdTooltip>

      <HdTooltip title={getSourceFieldDataTypeDisplay(field.source)} enableOnTextOverflow>
        <span className={`${styles.fieldType} text-ellipsis `}>
          {getSourceFieldDataTypeDisplay(field.source)}
        </span>
      </HdTooltip>

      {isStructField() && (
        <HdTooltip title='Click to view nested fields'>
          <HdIconButton
            size='small'
            className='ml-2'
            onClick={() => setOpen(true)}
            dataId={dataIdGenerator('show-nested-fields')}
          >
            <HdIcon className='text-primary' name='schema' />
          </HdIconButton>
        </HdTooltip>
      )}

      {field.keys && field.keys.length > 0 ? (
        <HdKeyBadge keys={field.keys} className={`${styles.keyBadge} ml-2`} />
      ) : null}

      {isOpen && (
        <NestedFieldExplorer
          childAccessor='nested'
          parentPath='root'
          field={constructDisplayField(field, 'nested')}
          onClose={() => setOpen(false)}
          open={isOpen}
        />
      )}
    </div>
  );
}
